import { graphql } from "@server/gql";

export const fragments = graphql(/* GraphQL */ `
  fragment brandPageProductList on ProductList {
    __typename
    sys {
      id
    }
    count
    heading
    linkText
    commerceData
    link {
      ... on Page {
        slug
      }
    }
  }
  fragment brandPage on Page {
    __typename
    sys {
      id
    }
    type
    slug
    se_slug: slug(locale: "sv-SE")
    no_slug: slug(locale: "nb-NO")
    dk_slug: slug(locale: "da-DK")
    fi_slug: slug(locale: "fi-FI")
    nl_slug: slug(locale: "nl-NL")
    en_slug: slug(locale: "en-GB")
    title
    desktopImage {
      ...contentfulAsset
    }
    desktopBackground {
      ...contentfulAsset
    }
    mobileImage {
      ...contentfulAsset
    }
    mobileBackground {
      ...contentfulAsset
    }
    subtitle
    metaTitle
    metaDescription
    description {
      json
      links {
        entries {
          hyperlink {
            __typename
            sys {
              id
            }
            ... on Page {
              slug
            }
            ... on EditorialPage {
              slug
            }
            ... on LandingPage {
              slug
            }
            ... on Campaign {
              slug
            }
          }
        }
      }
    }
    shortDescription
    commerceId
    commerceData
    commerceType
    commerceName
    sortProductsBy
    componentsCollection(limit: 2) {
      items {
        ...brandPageProductList
      }
    }
    footerBanner(where: { activeMarkets_contains_some: $activeMarkets }) {
      ...footerBanner
    }
    filtersCollection(limit: 25) {
      items {
        ... on Parametric {
          title
          attributeName
          type
          openByDefault
          minLabel
          maxLabel
          suffix
          prefix
        }
      }
    }
    featuredCollection(
      limit: 4
      where: { activeMarkets_contains_some: $activeMarkets }
    ) {
      items {
        ...feature
      }
    }
  }
  fragment brandPageSiteinfo on Siteinfo {
    header {
      navigation {
        __typename
        sys {
          id
        }
        sublinksCollection(limit: 12) {
          items {
            __typename
            sys {
              id
            }
            type
            title
            internalLink {
              ... on EditorialPage {
                __typename
                sys {
                  id
                }
                slug
                title
              }
              ... on LandingPage {
                __typename
                sys {
                  id
                }
                slug
                title
              }
              ... on Page {
                __typename
                sys {
                  id
                }
                slug
                title
                commerceData
                commerceId
                commerceName
              }
            }
          }
        }
      }
    }
  }
`);

export default graphql(/* GraphQL */ `
  query BrandPage(
    $locale: String!
    $brand: String!
    $category: String!
    $preview: Boolean
    $activeMarkets: [String]
  ) {
    siteinfoCollection(locale: $locale, limit: 1) {
      items {
        ...brandPageSiteinfo
      }
    }
    brand: page(locale: $locale, id: $brand, preview: $preview) {
      ...brandPage
    }
    category: page(locale: $locale, id: $category) {
      ...categoryPage
    }
  }
`);
